import { render, staticRenderFns } from "./WorkbenchBanner.vue?vue&type=template&id=3eacb975&"
import script from "./WorkbenchBanner.vue?vue&type=script&lang=js&"
export * from "./WorkbenchBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports